import React from 'react'

const ContentContainer = ({ children }) => <div>{children}</div>

export default ContentContainer
